<script lang="ts">
  /**
   * NarrationCard — a small text annotation that explains the current step.
   *
   * Sits below or beside an algorithm visual. Crossfades when the text changes
   * so the reader sees the narrative update without jarring layout shifts.
   */
  type Props = {
    text: string;
    /** Optional accent color for the left edge (uses --accent by default). */
    accent?: string;
  };

  let { text, accent = 'var(--accent)' }: Props = $props();
</script>

<div class="narration" style="--narration-accent: {accent};">
  {#key text}
    <p class="narration-text">{text}</p>
  {/key}
</div>

<style>
  .narration {
    border-left: 2px solid var(--narration-accent);
    padding: var(--space-sm) var(--space-md);
    background: var(--surface);
    min-height: 56px;
    display: flex;
    align-items: center;
    border-radius: 0 var(--radius-sm) var(--radius-sm) 0;
  }

  .narration-text {
    font-family: var(--font-sans);
    font-size: var(--text-sm);
    line-height: var(--leading-snug);
    color: var(--ink);
    margin: 0;
    animation: fade-in 240ms ease;
  }

  @keyframes fade-in {
    from {
      opacity: 0;
      transform: translateY(2px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
</style>
